import { Sparkles } from "lucide-react";

/** Kernpunten bovenaan een artikel: de belangrijkste feiten in één oogopslag. */
export function KeyTakeaways({ items }: { items: string[] }) {
  if (items.length === 0) return null;
  return (
    <section
      aria-labelledby="kernpunten"
      className="rounded-xl border border-border bg-secondary/40 p-6"
    >
      <p id="kernpunten" className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-foreground">
        <Sparkles className="h-4 w-4 text-success" aria-hidden />
        Kort samengevat
      </p>
      <ul className="mt-4 grid gap-3 sm:grid-cols-2">
        {items.map((item) => (
          <li key={item} className="flex gap-2 text-sm leading-relaxed text-muted-foreground">
            <span aria-hidden className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-success" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
